export interface BarRow { label: string; value: number; display?: string; color?: string }

export default function BarListPanel({ title, rows }: { title: string; rows: BarRow[] }) {
  const max = Math.max(1, ...rows.map((row) => row.value));
  return (
    <div className="bg-white border border-background-200 rounded-2xl p-5 md:p-6">
      <h3 className="font-heading font-semibold text-foreground-950 mb-4">{title}</h3>
      <ul className="flex flex-col gap-2.5">
        {rows.map((row) => (
          <li key={row.label} className="grid grid-cols-[minmax(0,9rem)_1fr_auto] items-center gap-3 text-sm">
            <span className="text-foreground-800 truncate" title={row.label}>{row.label}</span>
            <span className="h-2.5 rounded-full bg-[#eef0f4] overflow-hidden">
              <span className={`block h-full rounded-full ${row.color ?? 'bg-[#3b64e0]'}`} style={{ width: `${(row.value / max) * 100}%` }} />
            </span>
            <span className="font-semibold text-foreground-950 text-right min-w-10">{row.display ?? row.value.toLocaleString()}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
